import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { SharedModule } from '@kp/shared/shared.module';
import { ScreenPremiumPaywallComponent } from './screen-premium-paywall.component';

@NgModule({
  declarations: [ScreenPremiumPaywallComponent],
  imports: [HttpClientModule, CommonModule, SharedModule, TranslocoDirective],
  exports: [ScreenPremiumPaywallComponent],
})
export class ScreenPaywallModule {}
